import { render, staticRenderFns } from "./manufacturerHighlight.vue?vue&type=template&id=012841bc&"
import script from "./manufacturerHighlight.vue?vue&type=script&lang=js&"
export * from "./manufacturerHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports